<section class="asb-section">
  <div class="asb-wrap reusable-container">
    <article class="asb-card">
      <!-- Background layers -->
      <div class="asb-mesh"></div>
      <div class="asb-grid"></div>
      <div class="asb-grain"></div>
      <div class="asb-glow asb-glow-1"></div>
      <div class="asb-glow asb-glow-2"></div>

      <!-- Content -->
      <div class="asb-content">
        <div class="asb-eyebrow">
          <span class="pulse"></span>
          Available on every device
        </div>

        <h2 class="asb-title">
          Ready to elevate<br />
          your <span class="accent">meetings?</span>
        </h2>

        <p class="asb-sub">
          Join 10,000+ teams who trust eMikutano for daily meetings,
          collaboration, and strategic planning across any platform.
        </p>

        <!-- Store buttons -->
        <div class="asb-stores">
          @for (store of stores; track $index) {
            <button class="asb-store">
              <mat-icon class="asb-store-icon" [svgIcon]="store.icon"></mat-icon>
              <div class="asb-store-text">
                <span class="asb-store-label">Get it on</span>
                <span class="asb-store-name">{{ store.name }}</span>
              </div>
            </button>
          }
        </div>

        <!-- Trust row -->
        <div class="asb-trust">
          <div class="asb-trust-stars">
            <mat-icon>star</mat-icon>
            <mat-icon>star</mat-icon>
            <mat-icon>star</mat-icon>
            <mat-icon>star</mat-icon>
            <mat-icon>star</mat-icon>
            <span>4.9 rating</span>
          </div>
          <div class="asb-trust-divider"></div>
          <div class="asb-trust-item">
            <strong>500K+</strong> downloads
          </div>
          <div class="asb-trust-divider"></div>
          <div class="asb-trust-item">
            <strong>99.9%</strong> uptime SLA
          </div>
        </div>
      </div>

      <!-- Visual: phone + floating cards -->
      <div class="asb-visual">
        <!-- Phone mockup -->
        <div class="asb-phone">
          <img src="../../../../assets/svg/phones.svg" alt="eMikutano app" />
        </div>

        <!-- Floating QR card -->
        <div class="asb-qr">
          <div class="asb-qr-code">
            <div class="asb-qr-pattern"></div>
            <div class="asb-qr-logo">
              <mat-icon>videocam</mat-icon>
            </div>
          </div>
          <div class="asb-qr-text">
            <strong>Scan to install</strong>
            <span>Works on any phone</span>
          </div>
        </div>

        <!-- Floating download badge -->
        <div class="asb-badge">
          <div class="asb-badge-icon">
            <mat-icon>download</mat-icon>
          </div>
          <div class="asb-badge-text">
            <span class="asb-badge-count">+1,284</span>
            <span class="asb-badge-label">installs this week</span>
          </div>
        </div>

        <!-- Floating notification -->
        <div class="asb-notif">
          <div class="asb-notif-dot"></div>
          <div class="asb-notif-text">
            <strong>Meeting started</strong>
            <span>HD stream active</span>
          </div>
        </div>
      </div>
    </article>
  </div>
</section>
